import { createSvgIcon } from "@mui/material";
import DeleteSvg from '../../../img/create/design-lab-v4/icons/delete-v2.svg'

const DeleteIcon = createSvgIcon(<DeleteSvg/>, 'Delete');
export default DeleteIcon;